import { Button } from '@mui/material';

import useEffectOnceWhen from '@/hooks/useEffectOnceWhen';
import { Tabs as SettingsTabs } from '@/pages/Settings/Tabs/types';
import { BasetenPageEnum, usePageSwitcher } from '@/routes';
import { useOrgBudget } from '@/sections/Billing/hooks';
import { useSnackbar } from 'notistack';

// Only show once on app load.
let globalHasShown = false;

function useBudgetExceededSnackbar() {
  const { isSpendExceeded } = useOrgBudget();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const goToPage = usePageSwitcher();

  useEffectOnceWhen(!globalHasShown && isSpendExceeded, () => {
    globalHasShown = true;

    const key = enqueueSnackbar('Model API budget reached', {
      variant: 'error',
      persist: true,
      action: () => (
        <Button
          color="error"
          onClick={() => {
            goToPage(BasetenPageEnum.Settings, { tabId: SettingsTabs.Billing });
            closeSnackbar(key);
          }}
        >
          Billing and usage
        </Button>
      ),
    });
  });
}

export { useBudgetExceededSnackbar };
